module.exports = __webpack_public_path__ + "static/media/logo.b798b7d1.svg";